var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSouthSudan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 13.956,
    viewBox: "0 0 20 13.956",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.044)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47,60.779H27V56.471a.359.359,0,0,1,.346-.371H46.654a.359.359,0,0,1,.346.371l0,4.308Z",
    transform: "translate(-27 -56.056)",
    fill: "#464655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.649,272.679h-19.3a.359.359,0,0,1-.346-.371V268H47v4.313A.358.358,0,0,1,46.649,272.679Z",
    transform: "translate(-27 -258.679)",
    fill: "#73af00"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.996,
    height: 4.679,
    transform: "translate(0 4.658)",
    fill: "#ff4b55"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.96,192.9l.221.477.508-.124a.039.039,0,0,1,.044.053l-.234.468.415.318a.036.036,0,0,1-.018.066l-.513.106.009.526a.038.038,0,0,1-.062.031l-.406-.336-.407.336a.037.037,0,0,1-.062-.031l.009-.526-.513-.106a.039.039,0,0,1-.018-.066l.415-.318-.234-.468a.038.038,0,0,1,.044-.053l.508.124.221-.477A.039.039,0,0,1,94.96,192.9Z",
    transform: "translate(-90.965 -191.268)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.996,
    height: 0.627,
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.996,
    height: 0.627,
    transform: "translate(0 4.542)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.119,72.2l9.641-6.749a.181.181,0,0,0,0-.3L27.119,58.4a.356.356,0,0,0-.119.269V71.928A.372.372,0,0,0,27.119,72.2Z",
    transform: "translate(-27 -58.298)",
    fill: "#41479b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.21,174.951l.831.848,1.074-.508a.162.162,0,0,1,.212.221l-.557,1.052.817.862a.161.161,0,0,1-.141.27l-1.171-.2-.566,1.043a.161.161,0,0,1-.3-.053l-.172-1.175-1.166-.217a.159.159,0,0,1-.04-.3l1.06-.53-.155-1.18A.16.16,0,0,1,69.21,174.951Z",
    transform: "translate(-66.13 -169.675)",
    fill: "#ffe15a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthSudan);
export default __webpack_public_path__ + "static/media/South-Sudan.0773917cc8d382962ff5a194ad302223.svg";
export { ForwardRef as ReactComponent };